import { render } from "./StepFinallyReviews.vue?vue&type=template&id=054e5631&scoped=true"
import script from "./StepFinallyReviews.vue?vue&type=script&lang=js"
export * from "./StepFinallyReviews.vue?vue&type=script&lang=js"

import "./StepFinallyReviews.vue?vue&type=style&index=0&id=054e5631&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054e5631"]])

export default __exports__